export default __webpack_public_path__ + "static/media/thatchwalls.70d4da4b.png";